import React from "react";
import { graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import { buildBlocks } from "../../../services/builder";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const CgbCalloutCtaBlock = (props) => {
  const blocks = buildBlocks(
    props.innerBlocks,
    props.parentAttributes,
    props.pageContext
  );
  const classes = useStyles();

  let contained = "";

  if (props.attributes.contained === true) {
    contained = "contained";
  }

  return (
    <div
      className={`callout-cta ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.calloutCta} ${classes.calloutCtaTheme} ${contained}`}
    >
      <StaticImage
        src="../../../images/brass-texture.jpg"
        alt="Brass texture"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          minWidth: "100%",
          minHeight: "100%",
        }}
      />
      <Grid
        container
        spacing={3}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} md={7} lg={6} className="con-wrap">
          {blocks[1]}
          {blocks[0]}
        </Grid>
        <Grid item xs={false} md={1} lg={3} />
        <Grid item xs={12} md={4} lg={3}>
          {blocks[2]}
        </Grid>
      </Grid>
    </div>
  );
};

export const CgbCalloutCtaBlockFragment = graphql`
  fragment CgbCalloutCtaBlock on WpBlock {
    ... on WpCgbCalloutCtaBlock {
      name
      attributes {
        className
        contained
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbCalloutCtaBlockPreview = `
    ... on CgbCalloutCtaBlock {
        name
        attributes {
            className
            contained
        }
    }
`;
